import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
export default function EditBranchEditPolPod() {
  const history = useHistory();

  const [countryData, setCountryData] = useState([]);

  const [country, setCountry] = useState("");
  const [polpod_status, setPolPodstatus] = useState(0);
  const [polpod_name, setPolPod_name] = useState("");
  const [polpod_no, setPolPod_no] = useState("");
  let { id } = useParams();
  const data_params = { id: id };

  const SelectCountry = (event) => {
    setCountry(event.target.value);
  };

  const FetchCountry = async () => {
    try {
      const data = await api.get("api/master/country");
      setCountryData(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getData = async () => {
    try {
      const data = await api
        .post("api/polpod/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              setCountry(res.CountryId);

              setPolPod_name(res.PolPodName);
              setPolPod_no(res.PolPodNo);
              // res.Status.data.map((res) => {
              //   setPolPodstatus(res);
              //   //   console.log(res);
              // });
              setPolPodstatus(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/PolPod");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();

    FetchCountry();
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ท่าเรือ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Terminal
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Terminal
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            polpod_name: "",
            polpod_no: "",
            country_id: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!polpod_name || polpod_name === "") {
              errors.polpod_name = "Required";
            }
            if (!polpod_no || polpod_no === "") {
              errors.polpod_no = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: id,
                no: polpod_no,
                name: polpod_name,
                countryId: country,
                status: polpod_status,
              };

              api
                .post("/api/polpod/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขท่าเรือสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/PolPod");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });
              // alert(JSON.stringify(data, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                แก้ไขท่าเรือ
              </h6>
              <Grid container>
                <Grid item xs={6} sm={3} md={12}>
                  <TextField
                    name="polpod_name"
                    label="POL"
                    variant="outlined"
                    placeholder="Enter POL"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setPolPod_name(e.target.value)}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={polpod_name}
                  />
                  {errors.polpod_name &&
                    touched.polpod_name &&
                    errors.polpod_name}
                  <Grid item xs={12}>
                    <FormControl fullWidth required>
                      <InputLabel sx={{top:'10px', left:"10px"}}>Country</InputLabel>
                      <Select
                        value={country ? country : ""}
                        onChange={SelectCountry}
                        label="Country *"
                        style={{
                          width: "50%",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {countryData.map((option) => {
                          return (
                            <MenuItem
                              key={option.CountryId}
                              value={option.CountryId}
                            >
                              {option.CountryName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={10} sx={{ display: "flex" }}>
                  {/* <TextField
                    label="POL  NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter POL  NO."
                    name="polpod_no"
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setPolPod_no(e.target.value)}
                    onBlur={handleBlur}
                    value={polpod_no}
                  />
                  {errors.polpod_no && touched.polpod_no && errors.polpod_no} */}

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={polpod_status}
                      label="Status"
                      style={{
                        width: "40%",
                        
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={(e) => setPolPodstatus(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
